// src/utils/logger.ts
import log from "loglevel";
import { getEnvVar } from "@/utils/util";

const rawLogger = log.getLogger("app");

// Set log level
if (getEnvVar("LOG_MODE") === "development") {
  rawLogger.setLevel("debug");
} else {
  rawLogger.setLevel("warn");
}

// function reportToExternalTool(level: string, args: any[]) {
//   // Hook for Sentry later
// }

const createLogger = () => {
  return {
    debug: (...args: any[]) => rawLogger.debug(...args),
    info: (...args: any[]) => rawLogger.info(...args),
    warn: (...args: any[]) => rawLogger.warn(...args),
    error: (...args: any[]) => {
      rawLogger.error(...args);
    //   reportToExternalTool("error", args);
    },
  };
};

const logger = createLogger();
export default logger;